export enum OperationType {
  Insert,
  Get,
  Update,
  Delete
}